module.exports = __webpack_public_path__ + "img/mobile/SmartButton-auto/auto_bg_portrait@3x.png?0.0.53";